import styled from 'styled-components';

export const RadioInput = styled.input.attrs<{ disabled: boolean }>({
  type: 'radio'
})`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_40};
  display: flex;
  justify-content: center;
  align-items: center;

  &:checked {
    border-color: ${({ theme, disabled }): string =>
      disabled ? theme.palette_gray_40 : theme.palette_blue_100};
    border-width: 2px;
    background-color: ${({ theme, disabled }): string =>
      disabled ? theme.palette_gray_5 : theme.palette_blue_5};
  }

  &:checked::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ theme, disabled }): string =>
      disabled ? theme.palette_gray_100 : theme.palette_blue_100};
  }
`;
